export interface Result<T> {
  value: T;
  isSuccess: boolean;
  isFailure: boolean;
  isEmpty: boolean;
  message: string;
  httpStatusCode: number;
  resultType: ResultType;
}

export interface ResultV2 {
  Message: string;
}

export enum ResultType {
  InternalError = 0,
  Ok = 1,
  NotFound = 2,
  Forbidden = 3,
  Conflicted = 4,
  Invalid = 5,
  Unauthorized = 6,
}

export class aaDataResponse<T> {
  constructor(public aaData: T[], public iTotalRecords: number) {}
}
